export const PLATFORMS = {
  ACC: 'acc',
  BIM360: 'bim360',
  CPA: 'cpa',
} as const;

export type Platforms = typeof PLATFORMS;
export type Platform = Platforms[keyof Platforms];

export const ENVS = {
  QA: 'QA',
  STAGING: 'STAGING',
  PRODUCTION: 'PRODUCTION',
} as const;

export type Envs = typeof ENVS;
export type Env = Envs[keyof Envs];

export const PARTITIONS = {
  COMMERCIAL: 'COMMERCIAL',
  GOVCLOUD: 'GOVCLOUD',
  FEDRAMP_LEGACY: 'FEDRAMP_LEGACY',
} as const;

export type Partitions = typeof PARTITIONS;
export type Partition = Partitions[keyof Partitions];

export const APIGEE_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://developer-stg.api.autodesk.com',
  [ENVS.STAGING]: 'https://developer-stg.api.autodesk.com',
  [ENVS.PRODUCTION]: 'https://developer.api.autodesk.com',
};

export const OXYGEN_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://accounts-staging.autodesk.com',
  [ENVS.STAGING]: 'https://accounts-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'https://accounts.autodesk.com',
};

export const USER_PROFILE_URL: Record<Env, string> = {
  [ENVS.QA]: 'https://profile-stg.autodesk.com',
  [ENVS.STAGING]: 'https://profile-stg.autodesk.com',
  [ENVS.PRODUCTION]: 'https://profile.autodesk.com',
};

export const BC_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'app-stage.buildingconnected.com',
  [ENVS.PRODUCTION]: 'app.buildingconnected.com',
};

export const BIM360_ADMIN_URL: Record<Env, string> = {
  [ENVS.QA]: 'ea-api-qa',
  [ENVS.STAGING]: 'ea-api',
  [ENVS.PRODUCTION]: 'ea-api',
};
export const ADMIN_API_URL: Record<Env, string> = {
  [ENVS.QA]: 'bim360-qa/admin',
  [ENVS.STAGING]: 'bim360/admin',
  [ENVS.PRODUCTION]: 'bim360/admin',
};
export const ADMIN_CONSTRUCTION_API_URL: Record<Env, string> = {
  [ENVS.QA]: 'construction-qa/admin',
  [ENVS.STAGING]: 'construction/admin',
  [ENVS.PRODUCTION]: 'construction/admin',
};
export const RELATIONSHIP_API_URL: Record<Env, string> = {
  [ENVS.QA]: 'bim360/relationship-dev',
  [ENVS.STAGING]: 'bim360/relationship',
  [ENVS.PRODUCTION]: 'bim360/relationship',
};
export const REPORTS_V2_URL: Record<Env, string> = {
  [ENVS.QA]: 'reports-qa/v2',
  [ENVS.STAGING]: 'reports/v2',
  [ENVS.PRODUCTION]: 'reports/v2',
};
export const FORMS_API_URL: Record<Env, string> = {
  [ENVS.QA]: 'construction/forms-qa',
  [ENVS.STAGING]: 'construction/forms',
  [ENVS.PRODUCTION]: 'construction/forms',
};

export const BIM360_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: 'b360-qa.autodesk.com',
  [ENVS.STAGING]: 'b360-staging.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.autodesk.com',
};

export const BIM360_EMEA_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'b360-staging.eu.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.eu.autodesk.com',
};

export const BIM360_FEDRAMP_HOSTNAMES: Record<Env, string> = {
  [ENVS.QA]: '',
  [ENVS.STAGING]: 'b360-staging.afg.us.autodesk.com',
  [ENVS.PRODUCTION]: 'b360.afg.us.autodesk.com',
};

/** Primary apex domain per Autodesk partition (R13N standard). */
export const PARTITION_DOMAINS: Record<Partition, string> = {
  [PARTITIONS.COMMERCIAL]: 'autodesk.com',
  [PARTITIONS.GOVCLOUD]: 'autodesk.us',
  [PARTITIONS.FEDRAMP_LEGACY]: 'afg.us.autodesk.com',
};

/** Commercial-only; EU ACC uses autodesk.eu instead of regional autodesk.com. */
export const COMMERCIAL_EU_DOMAIN = 'autodesk.eu';
